const types = {
  RESET: "RESET",

  RESET_USER: "RESET_USER",
  SET_USER: "SET_USER",
  ADD_USER: "ADD_USER",
  UPDATE_USER: "UPDATE_USER",
  DELETE_USER: "DELETE_USER",
  USER_INITED: "USER_INITED",

  RESET_PET: "RESET_PET",
  SET_PET: "SET_PET",
  ADD_PET: "ADD_PET",
  UPDATE_PET: "UPDATE_PET",
  DELETE_PET: "DELETE_PET",
  PET_INITED: "PET_INITED",

  SET_STAFF: "SET_STAFF",
  ADD_STAFF: "ADD_STAFF",
  UPDATE_STAFF: "UPDATE_STAFF",
  DELETE_STAFF: "DELETE_STAFF",

  SET_TODAY_RECORD: "SET_TODAY_RECORD",
  ADD_TODAY_RECORD: "ADD_TODAY_RECORD",
  UPDATE_TODAY_RECORD: "UPDATE_TODAY_RECORD",
  DELETE_TODAY_RECORD: "DELETE_TODAY_RECORD",

  SET_TODAY_BOOKING: "SET_TODAY_BOOKING",
  ADD_TODAY_BOOKING: "ADD_TODAY_BOOKING",
  UPDATE_TODAY_BOOKING: "UPDATE_TODAY_BOOKING",
  DELETE_TODAY_BOOKING: "DELETE_TODAY_BOOKING",

  SET_TODAY_IN_HOSPITAL: "SET_TODAY_IN_HOSPITAL",
  ADD_TODAY_IN_HOSPITAL: "ADD_TODAY_IN_HOSPITAL",
  UPDATE_TODAY_IN_HOSPITAL: "UPDATE_TODAY_IN_HOSPITAL",
  DELETE_TODAY_IN_HOSPITAL: "DELETE_TODAY_IN_HOSPITAL",

  SET_CHECK_DATA: "SET_CHECK_DATA",
  ADD_CHECK_DATA: "ADD_CHECK_DATA",
  UPDATE_CHECK_DATA: "UPDATE_CHECK_DATA",
  DELETE_CHECK_DATA: "DELETE_CHECK_DATA",

  SET_CHECK_BOOKING: "SET_CHECK_BOOKING",
  ADD_CHECK_BOOKING: "ADD_CHECK_BOOKING",
  UPDATE_CHECK_BOOKING: "UPDATE_CHECK_BOOKING",
  DELETE_CHECK_BOOKING: "DELETE_CHECK_BOOKING",

  INIT_WAITING: "INIT_WAITING",
  DELETE_WAITING: "DELETE_WAITING",

  INIT_HISTORY_UNDONE_RECORD: "INIT_HISTORY_UNDONE_RECORD",
  DELETE_HISTORY_UNDONE_RECORD: "DELETE_HISTORY_UNDONE_RECORD",

  INIT_HISTORY_UNDONE_BILL: "INIT_HISTORY_UNDONE_BILL",
  DELETE_HISTORY_UNDONE_BILL: "DELETE_HISTORY_UNDONE_BILL",

  INIT_EXAM_TODO: "INIT_EXAM_TODO",
  DELETE_EXAM_TODO: "DELETE_EXAM_TODO",
  INIT_DISPENSE_TODO: "INIT_DISPENSE_TODO",
  DELETE_DISPENSE_TODO: "DELETE_DISPENSE_TODO",
  INIT_VERIFY_TODO: "INIT_VERIFY_TODO",
  DELETE_VERIFY_TODO: "DELETE_VERIFY_TODO",
  ADD_VERIFY_TODO: "ADD_VERIFY_TODO",
  UPDATE_VERIFY_TODO: "UPDATE_VERIFY_TODO",

  INIT_IN_HOSPITAL_TODO: "INIT_IN_HOSPITAL_TODO",
  DELETE_IN_HOSPITAL_TODO: "DELETE_IN_HOSPITAL_TODO",

  INIT_IN_HOSPITAL_BILLING: "INIT_IN_HOSPITAL_BILLING",
  INIT_IN_HOSPITAL_TWOWEEK_BILLING: "INIT_IN_HOSPITAL_TWOWEEK_BILLING",
  DELETE_IN_HOSPITAL_BILLING: "DELETE_IN_HOSPITAL_BILLING",

  SET_SETTING: "SET_SETTING",
  SET_TREATMENT_SETTING: "SET_TREATMENT_SETTING",

  SET_ROLE: "SET_ROLE",
  ADD_ROLE: "ADD_ROLE",
  UPDATE_ROLE: "UPDATE_ROLE",
  DELETE_ROLE: "DELETE_ROLE",

  SET_REMINDER: "SET_REMINDER",
  UPDATE_REMINDER: "UPDATE_REMINDER",
  DELETE_REMINDER: "DELETE_REMINDER",

  SET_SYNC_TOOL: "SET_SYNC_TOOL",
  ADD_SYNC_TOOL: "ADD_SYNC_TOOL",
  UPDATE_SYNC_TOOL: "UPDATE_SYNC_TOOL",
  DELETE_SYNC_TOOL: "DELETE_SYNC_TOOL",

  SET_DEVICE_EXAM: "SET_DEVICE_EXAM",
  ADD_DEVICE_EXAM: "ADD_DEVICE_EXAM",
  UPDATE_DEVICE_EXAM: "UPDATE_DEVICE_EXAM",
  DELETE_DEVICE_EXAM: "DELETE_DEVICE_EXAM",

  SET_RECORD_EXAM: "SET_RECORD_EXAM",
  ADD_RECORD_EXAM: "ADD_RECORD_EXAM",
  UPDATE_RECORD_EXAM: "UPDATE_RECORD_EXAM",
  DELETE_RECORD_EXAM: "DELETE_RECORD_EXAM",
};

const module = {
  namespaced: true,
  state: {
    // modify types.RESET too
    users: [],
    usersDic: {},
    userInited: false,
    pets: [],
    petsDic: {},
    petInited: true,
    staffs: [],
    todayRecords: [],
    historyUndoneRecords: [],
    historyUndoneBills: [],
    todayBookings: [],
    todayInHospitals: [],
    checkData: [],
    checkBooking: [],
    waiting: [],
    examTodo: [],
    dispenseTodo: [],
    verifyTodo: [],
    inHospitalTodo: [],
    inHospitalBilling: [],
    setting: {},
    treatmentSetting: {},
    roles: [],
    reminders: [],
    synctools: [],
    userFields: [
      "_id",
      "name",
      "nameLowerCase",
      "phone",
      "IDcard",
      "updateDateTime",
    ],
    petFields: [
      "_id",
      "name",
      "status",
      "userID",
      "nameLowerCase",
      "updateDateTime",
      "approvalStatus",
    ],
    deviceExams: [],
    recordExams: [],
  },
  actions: {
    //reset action==================================
    async actionReset({ commit }) {
      commit(types.RESET);
    },
    //user action===================================
    async actionResetUser({ commit }) {
      commit(types.RESET_USER);
    },
    async actionSetUser({ commit }, users) {
      commit(types.SET_USER, users);
    },
    async actionAddUser({ commit }, user) {
      commit(types.ADD_USER, user);
    },
    async actionDeleteUser({ commit }, id) {
      commit(types.DELETE_USER, id);
    },
    async actionUpdateUser({ commit }, user) {
      commit(types.UPDATE_USER, user);
    },
    async actionUserInited({ commit }, status) {
      commit(types.USER_INITED, status);
    },
    //pet action===================================

    async actionResetPet({ commit }) {
      commit(types.RESET_PET);
    },
    async actionSetPet({ commit }, pets) {
      commit(types.SET_PET, pets);
    },
    async actionAddPet({ commit }, pet) {
      commit(types.ADD_PET, pet);
    },
    async actionDeletePet({ commit }, id) {
      commit(types.DELETE_PET, id);
    },
    async actionUpdatePet({ commit }, pet) {
      commit(types.UPDATE_PET, pet);
    },
    async actionPetInited({ commit }, status) {
      commit(types.PET_INITED, status);
    },
    //staff action===================================
    async actionSetStaff({ commit }, staffs) {
      commit(types.SET_STAFF, staffs);
    },
    async actionAddStaff({ commit }, staff) {
      commit(types.ADD_STAFF, staff);
    },
    async actionDeleteStaff({ commit }, id) {
      commit(types.DELETE_STAFF, id);
    },
    async actionUpdateStaff({ commit }, staff) {
      commit(types.UPDATE_STAFF, staff);
    },
    //record action===================================
    async actionSetTodayRecord({ commit }, records) {
      commit(types.SET_TODAY_RECORD, records);
    },
    async actionAddTodayRecord({ commit }, record) {
      commit(types.ADD_TODAY_RECORD, record);
    },
    async actionDeleteTodayRecord({ commit }, id) {
      commit(types.DELETE_TODAY_RECORD, id);
    },
    async actionUpdateTodayRecord({ commit }, record) {
      commit(types.UPDATE_TODAY_RECORD, record);
    },
    //booking action===================================
    async actionSetTodayBooking({ commit }, bookings) {
      commit(types.SET_TODAY_BOOKING, bookings);
    },
    async actionAddTodayBooking({ commit }, booking) {
      commit(types.ADD_TODAY_BOOKING, booking);
    },
    async actionDeleteTodayBooking({ commit }, id) {
      commit(types.DELETE_TODAY_BOOKING, id);
    },
    async actionUpdateTodayBooking({ commit }, booking) {
      commit(types.UPDATE_TODAY_BOOKING, booking);
    },
    //inHospital action===================================
    async actionSetTodayInHospital({ commit }, inHospitals) {
      commit(types.SET_TODAY_IN_HOSPITAL, inHospitals);
    },
    async actionAddTodayInHospital({ commit }, inHospital) {
      commit(types.ADD_TODAY_IN_HOSPITAL, inHospital);
    },
    async actionDeleteTodayInHospital({ commit }, id) {
      commit(types.DELETE_TODAY_IN_HOSPITAL, id);
    },
    async actionUpdateTodayInHospital({ commit }, inHospital) {
      commit(types.UPDATE_TODAY_IN_HOSPITAL, inHospital);
    },
    //check data action===================================
    async actionSetCheckData({ commit }, pets) {
      commit(types.SET_CHECK_DATA, pets);
    },
    async actionAddCheckData({ commit }, pet) {
      commit(types.ADD_CHECK_DATA, pet);
    },
    async actionUpdateCheckData({ commit }, pet) {
      commit(types.UPDATE_CHECK_DATA, pet);
    },
    async actionDeleteCheckData({ commit }, id) {
      commit(types.DELETE_CHECK_DATA, id);
    },
    //check booking action===================================
    async actionSetCheckBooking({ commit }, bookings) {
      commit(types.SET_CHECK_BOOKING, bookings);
    },
    async actionAddCheckBooking({ commit }, booking) {
      commit(types.ADD_CHECK_BOOKING, booking);
    },
    async actionUpdateCheckBooking({ commit }, booking) {
      commit(types.UPDATE_CHECK_BOOKING, booking);
    },
    async actionDeleteCheckBooking({ commit }, id) {
      commit(types.DELETE_CHECK_BOOKING, id);
    },
    //record waiting action==========================
    async actionInitWaiting({ commit }, records) {
      commit(types.INIT_WAITING, records);
    },
    async actionDeleteWaiting({ commit }, id) {
      commit(types.DELETE_WAITING, id);
    },
    //record history undone action==========================
    async actionInitHistoryUndoneRecord({ commit }, records) {
      commit(types.INIT_HISTORY_UNDONE_RECORD, records);
    },
    async actionDeleteHistoryUndoneRecord({ commit }, id) {
      commit(types.DELETE_HISTORY_UNDONE_RECORD, id);
    },
    //bills history undone action==========================
    async actionInitHistoryUndoneBill({ commit }, records) {
      commit(types.INIT_HISTORY_UNDONE_BILL, records);
    },
    async actionDeleteHistoryUndoneBill({ commit }, id) {
      commit(types.DELETE_HISTORY_UNDONE_BILL, id);
    },
    //exam todo action==========================
    async initExamTodo({ commit }, records) {
      commit(types.INIT_EXAM_TODO, records);
    },
    async deleteExamTodo({ commit }, id) {
      commit(types.DELETE_EXAM_TODO, id);
    },
    //dispense todo action==========================
    async initDispenseTodo({ commit }, records) {
      commit(types.INIT_DISPENSE_TODO, records);
    },
    async deleteDispenseTodo({ commit }, id) {
      commit(types.DELETE_DISPENSE_TODO, id);
    },
    //verify todo action==========================
    async initVerifyTodo({ commit }, verifies) {
      commit(types.INIT_VERIFY_TODO, verifies);
    },
    async deleteVerifyTodo({ commit }, id) {
      commit(types.DELETE_VERIFY_TODO, id);
    },
    async addVerifyTodo({ commit }, verify) {
      commit(types.ADD_VERIFY_TODO, verify);
    },
    async updateVerifyTodo({ commit }, verify) {
      commit(types.UPDATE_VERIFY_TODO, verify);
    },
    //inHospital todo action==========================
    async actionInHospitalTodo({ commit }, inHospitals) {
      commit(types.INIT_IN_HOSPITAL_TODO, inHospitals);
    },
    async actionDeleteInHospitalTodo({ commit }, id) {
      commit(types.DELETE_IN_HOSPITAL_TODO, id);
    },
    //inHospital billing action==========================
    async actionInHospitalBilling({ commit }, inHospitals) {
      commit(types.INIT_IN_HOSPITAL_BILLING, inHospitals);
    },
    async actionTwoWeekInHospitalBilling({ commit }, inHospitals) {
      commit(types.INIT_IN_HOSPITAL_TWOWEEK_BILLING, inHospitals);
    },
    async actionDeleteInHospitalBilling({ commit }, id) {
      commit(types.DELETE_IN_HOSPITAL_BILLING, id);
    },
    //setting action===================================
    async actionSetSetting({ commit }, setting) {
      commit(types.SET_SETTING, setting);
    },
    async actionSetTreatmentSetting({ commit }, treatmentSetting) {
      commit(types.SET_TREATMENT_SETTING, treatmentSetting);
    },
    //set roles=================================
    async actionSetRoles({ commit }, roles) {
      commit(types.SET_ROLE, roles);
    },
    async actionAddRole({ commit }, role) {
      commit(types.ADD_ROLE, role);
    },
    async actionDeleteRole({ commit }, id) {
      commit(types.DELETE_ROLE, id);
    },
    async actionUpdateRole({ commit }, role) {
      commit(types.UPDATE_ROLE, role);
    },
    //reminders action=================================
    async actionSetReminder({ commit }, reminders) {
      commit(types.SET_REMINDER, reminders);
    },
    async actionDeleteReminder({ commit }, id) {
      commit(types.DELETE_REMINDER, id);
    },
    async actionUpdateReminder({ commit }, reminder) {
      commit(types.UPDATE_REMINDER, reminder);
    },

    //synctool action===================================
    async actionSetSynctool({ commit }, synctools) {
      commit(types.SET_SYNC_TOOL, synctools);
    },
    async actionAddSynctool({ commit }, synctool) {
      commit(types.ADD_SYNC_TOOL, synctool);
    },
    async actionDeleteSynctool({ commit }, id) {
      commit(types.DELETE_SYNC_TOOL, id);
    },
    async actionUpdateSynctool({ commit }, synctool) {
      commit(types.UPDATE_SYNC_TOOL, synctool);
    },
    //device exam action===================================
    async actionSetDeviceExam({ commit }, deviceExams) {
      commit(types.SET_DEVICE_EXAM, deviceExams);
    },
    async actionAddDeviceExam({ commit }, exam) {
      commit(types.ADD_DEVICE_EXAM, exam);
    },
    async actionDeleteDeviceExam({ commit }, id) {
      commit(types.DELETE_DEVICE_EXAM, id);
    },
    async actionUpdateDeviceExam({ commit }, exam) {
      commit(types.UPDATE_DEVICE_EXAM, exam);
    },
    //record exam action===================================
    async actionSetRecordExam({ commit }, recordExams) {
      commit(types.SET_RECORD_EXAM, recordExams);
    },
    async actionAddRecordExam({ commit }, exam) {
      commit(types.ADD_RECORD_EXAM, exam);
    },
    async actionDeleteRecordExam({ commit }, id) {
      commit(types.DELETE_RECORD_EXAM, id);
    },
    async actionUpdateRecordExam({ commit }, exam) {
      commit(types.UPDATE_RECORD_EXAM, exam);
    },
  },
  mutations: {
    //reset mutation===================================
    [types.RESET](state) {
      state.users = [];
      state.usersDic = {};
      state.pets = [];
      state.petsDic = {};
      state.staffs = [];
      state.todayRecords = [];
      state.todayBookings = [];
      state.checkData = [];
      state.checkBooking = [];
      state.todayInHospitals = [];
      state.waiting = [];
      state.examTodo = [];
      state.dispenseTodo = [];
      state.verifyTodo = [];
      state.setting = {};
      state.roles = [];
      state.reminders = [];
      state.synctools = [];
    },
    //user mutation===================================
    [types.RESET_USER](state) {
      // state.users = users;
      state.users = [];
      state.usersDic = {};
    },
    [types.SET_USER](state, users = []) {
      // state.users = users;
      state.users = state.users.concat(users);
      state.usersDic = users.reduce(function (map, obj) {
        map[obj._id] = obj;
        return map;
      }, {});
    },
    [types.ADD_USER](state, user) {
      let simplify = {};
      (state.userFields || []).forEach((field) => {
        simplify[field] = user[field];
      });

      state.users.unshift(simplify);
      state.usersDic[user._id] = simplify;
    },
    [types.DELETE_USER](state, id) {
      let index = state.users.findIndex((user) => user._id === id);
      if (index > -1) {
        state.users.splice(index, 1);
      }
      delete state.usersDic[id];
    },
    [types.UPDATE_USER](state, newUser) {
      let simplify = {};
      (state.userFields || []).forEach((field) => {
        simplify[field] = newUser[field];
      });

      let index = state.users.findIndex((user) => user._id === newUser._id);
      if (index > -1) {
        state.users.splice(index, 1, simplify);
      } else {
        state.users.unshift(simplify);
      }
      state.usersDic[newUser._id] = simplify;
    },

    [types.USER_INITED](state, status) {
      state.userInited = status;
    },
    //pet mutation===================================

    [types.RESET_PET](state) {
      state.pets = [];
      state.petsDic = {};
    },
    [types.SET_PET](state, pets = []) {
      state.pets = state.pets.concat(pets);
      state.petsDic = pets.reduce(function (map, obj) {
        map[obj._id] = obj;
        return map;
      }, {});
    },
    [types.ADD_PET](state, pet) {
      let simplify = {};
      (state.petFields || []).forEach((field) => {
        simplify[field] = pet[field];
      });
      simplify.avatar = window.NxVetV2.getPetAvatar(pet._id, pet.breed);

      state.pets.unshift(simplify);
      state.petsDic[pet._id] = simplify;
    },
    [types.DELETE_PET](state, id) {
      let index = state.pets.findIndex((pet) => pet._id === id);
      if (index > -1) {
        state.pets.splice(index, 1);
      }
      delete state.petsDic[id];
    },
    [types.UPDATE_PET](state, newPet) {
      let simplify = {};
      (state.petFields || []).forEach((field) => {
        simplify[field] = newPet[field];
      });
      simplify.avatar = window.NxVetV2.getPetAvatar(newPet._id, newPet.breed);

      let index = state.pets.findIndex((pet) => pet._id === newPet._id);
      if (index > -1) {
        state.pets.splice(index, 1, simplify);
      } else {
        state.pets.unshift(simplify);
      }
      state.petsDic[newPet._id] = simplify;
    },
    [types.PET_INITED](state, status) {
      state.petInited = status;
    },
    //staff mutation===================================
    [types.SET_STAFF](state, staffs = []) {
      // state.staffs = staffs;
      state.staffs = state.staffs.concat(staffs);
    },
    [types.ADD_STAFF](state, staff) {
      state.staffs.unshift(staff);
    },
    [types.DELETE_STAFF](state, id) {
      let index = state.staffs.findIndex((staff) => staff._id === id);
      if (index > -1) {
        state.staffs.splice(index, 1);
      }
    },
    [types.UPDATE_STAFF](state, newStaff) {
      let index = state.staffs.findIndex((staff) => staff._id === newStaff._id);
      if (index > -1) {
        state.staffs.splice(index, 1, newStaff);
      }
    },
    //record mutation===================================
    [types.SET_TODAY_RECORD](state, records = []) {
      state.todayRecords = records;
      // state.todayRecords = state.todayRecords.concat(records);
    },
    [types.ADD_TODAY_RECORD](state, record) {
      state.todayRecords.unshift(record);
    },
    [types.DELETE_TODAY_RECORD](state, id) {
      let index = state.todayRecords.findIndex((record) => record._id === id);
      if (index > -1) {
        state.todayRecords.splice(index, 1);
      }
    },
    [types.UPDATE_TODAY_RECORD](state, newRecord) {
      let index = state.todayRecords.findIndex(
        (record) => record._id === newRecord._id
      );
      if (index > -1) {
        state.todayRecords.splice(index, 1, newRecord);
      } else {
        // console.log("#update today record:" + JSON.stringify(newRecord));
        state.todayRecords.push(newRecord);
      }
    },
    //booking mutation===================================
    [types.SET_TODAY_BOOKING](state, bookings = []) {
      // state.todayBookings = bookings;
      state.todayBookings = state.todayBookings.concat(bookings);
    },
    [types.ADD_TODAY_BOOKING](state, booking) {
      state.todayBookings.unshift(booking);
    },
    [types.DELETE_TODAY_BOOKING](state, id) {
      let index = state.todayBookings.findIndex(
        (booking) => booking._id === id
      );
      if (index > -1) {
        state.todayBookings.splice(index, 1);
      }
    },
    [types.UPDATE_TODAY_BOOKING](state, newBooking) {
      let index = state.todayBookings.findIndex(
        (booking) => booking._id === newBooking._id
      );
      if (index > -1) {
        state.todayBookings.splice(index, 1, newBooking);
      } else {
        state.todayBookings.push(newBooking);
      }
    },
    //inHospital mutation===================================
    [types.SET_TODAY_IN_HOSPITAL](state, inHospitals = []) {
      state.todayInHospitals = state.todayInHospitals.concat(inHospitals);
    },
    [types.ADD_TODAY_IN_HOSPITAL](state, inHospital) {
      state.todayInHospitals.unshift(inHospital);
    },
    [types.DELETE_TODAY_IN_HOSPITAL](state, id) {
      let index = state.todayInHospitals.findIndex(
        (inHospital) => inHospital._id === id
      );
      if (index > -1) {
        state.todayInHospitals.splice(index, 1);
      }
    },
    [types.UPDATE_TODAY_IN_HOSPITAL](state, newInHospital) {
      let index = state.todayInHospitals.findIndex(
        (inHospital) => inHospital._id === newInHospital._id
      );
      if (index > -1) {
        state.todayInHospitals.splice(index, 1, newInHospital);
      } else {
        state.todayInHospitals.push(newInHospital);
      }
    },
    // state.checkData = [];
    // //check data mutation===================================
    [types.SET_CHECK_DATA](state, pets = []) {
      let simplify = [];
      if (pets.length) {
        simplify = pets.map((pet) => {
          return {
            _id: pet._id,
            updateDateTime: pet.updateDateTime,
            approvalStatus: pet.approvalStatus,
          };
        });
      }

      state.checkData = state.checkData.concat(simplify);

      console.log(JSON.stringify(state.checkData));
    },
    [types.ADD_CHECK_DATA](state, pet) {
      if (pet.approvalStatus == 10) {
        state.checkData.unshift({
          _id: pet._id,
          updateDateTime: pet.updateDateTime,
          approvalStatus: pet.approvalStatus,
        });
      }
    },
    [types.UPDATE_CHECK_DATA](state, newPet) {
      let index = state.checkData.findIndex((pet) => pet._id === newPet._id);
      if (index > -1) {
        state.checkData.splice(index, 1);
      }
      if (newPet.approvalStatus == 10) {
        state.checkData.push({
          _id: newPet._id,
          updateDateTime: newPet.updateDateTime,
          approvalStatus: newPet.approvalStatus,
        });
      }
    },
    [types.DELETE_CHECK_DATA](state, id) {
      let index = state.checkData.findIndex((pet) => pet._id === id);
      if (index > -1) {
        state.checkData.splice(index, 1);
      }
    },
    //check booking mutation===================================
    [types.SET_CHECK_BOOKING](state, bookings = []) {
      state.checkBooking = state.checkBooking.concat(bookings);
    },
    [types.ADD_CHECK_BOOKING](state, booking) {
      if (booking.bookingStatus == "pending") {
        state.checkBooking.unshift(booking);
      }
    },
    [types.UPDATE_CHECK_BOOKING](state, newBooking) {
      let index = state.checkBooking.findIndex(
        (booking) => booking._id === newBooking._id
      );
      if (index > -1) {
        state.checkBooking.splice(index, 1);
      }
      if (newBooking.bookingStatus == "pending") {
        state.checkBooking.push(newBooking);
      }
    },
    [types.DELETE_CHECK_BOOKING](state, id) {
      let index = state.checkBooking.findIndex((booking) => booking._id === id);
      if (index > -1) {
        state.checkBooking.splice(index, 1);
      }
    },
    //record waiting mutation===================================
    [types.INIT_WAITING](state, records = []) {
      state.waiting = records;
    },
    [types.DELETE_WAITING](state, id) {
      let index = state.waiting.findIndex((record) => record._id === id);
      if (index > -1) {
        state.waiting.splice(index, 1);
      }
    },
    //record history undone mutation===================================
    [types.INIT_HISTORY_UNDONE_RECORD](state, records = []) {
      state.historyUndoneRecords = records;
    },
    [types.DELETE_HISTORY_UNDONE_RECORD](state, id) {
      let index = state.historyUndoneRecords.findIndex(
        (record) => record._id === id
      );
      if (index > -1) {
        state.historyUndoneRecords.splice(index, 1);
      }
    },
    //bill history undone mutation===================================
    [types.INIT_HISTORY_UNDONE_BILL](state, records = []) {
      state.historyUndoneBills = records;
    },
    [types.DELETE_HISTORY_UNDONE_BILL](state, id) {
      let index = state.historyUndoneBills.findIndex(
        (record) => record._id === id
      );
      if (index > -1) {
        state.historyUndoneBills.splice(index, 1);
      }
    },
    //exam todo mutation===================================
    [types.INIT_EXAM_TODO](state, records = []) {
      state.examTodo = records;
    },
    [types.DELETE_EXAM_TODO](state, id) {
      let index = state.examTodo.findIndex((record) => record._id === id);
      if (index > -1) {
        state.examTodo.splice(index, 1);
      }
    },
    //dispense todo mutation===================================
    [types.INIT_DISPENSE_TODO](state, records = []) {
      state.dispenseTodo = records;
    },
    [types.DELETE_DISPENSE_TODO](state, id) {
      let index = state.dispenseTodo.findIndex((record) => record._id === id);
      if (index > -1) {
        state.dispenseTodo.splice(index, 1);
      }
    },
    //verify todo mutation===================================
    [types.INIT_VERIFY_TODO](state, verifies = []) {
      state.verifyTodo = verifies;
    },
    [types.DELETE_VERIFY_TODO](state, id) {
      let index = state.verifyTodo.findIndex((record) => record._id === id);
      if (index > -1) {
        state.verifyTodo.splice(index, 1);
      }
    },
    [types.ADD_VERIFY_TODO](state, verify) {
      state.verifyTodo.unshift(verify);
    },
    [types.UPDATE_VERIFY_TODO](state, newVerify) {
      let index = state.verifyTodo.findIndex(
        (verify) => verify._id === newVerify._id
      );
      if (index > -1) {
        state.verifyTodo.splice(index, 1, newVerify);
      } else {
        state.verifyTodo.push(newVerify);
      }
    },
    //inHospital todo mutation===================================
    [types.INIT_IN_HOSPITAL_TODO](state, inHospitals = []) {
      state.inHospitalTodo = inHospitals;
    },
    [types.DELETE_IN_HOSPITAL_TODO](state, id) {
      let index = state.inHospitalTodo.findIndex(
        (inHospital) => inHospital._id === id
      );
      if (index > -1) {
        state.inHospitalTodo.splice(index, 1);
      }
    },
    //inHospital billing mutation===================================
    [types.INIT_IN_HOSPITAL_BILLING](state, inHospitals = []) {
      state.inHospitalBilling = inHospitals;
    },
    [types.INIT_IN_HOSPITAL_TWOWEEK_BILLING](state, inHospitals = []) {
      state.twoWeekInHospitalBilling = inHospitals;
    },
    [types.DELETE_IN_HOSPITAL_BILLING](state, id) {
      let index = state.inHospitalBilling.findIndex(
        (inHospital) => inHospital._id === id
      );
      if (index > -1) {
        state.inHospitalBilling.splice(index, 1);
      }
    },
    //setting mutation===================================
    [types.SET_SETTING](state, setting = {}) {
      state.setting = setting;
    },
    [types.SET_TREATMENT_SETTING](state, treatmentSetting = {}) {
      state.treatmentSetting = treatmentSetting;
    },
    //role mutation===================================
    [types.SET_ROLE](state, roles = []) {
      // state.roles = roles;
      state.roles = state.roles.concat(roles);
    },
    [types.ADD_ROLE](state, role) {
      state.roles.unshift(role);
    },
    [types.DELETE_ROLE](state, id) {
      let index = state.roles.findIndex((role) => role._id === id);
      if (index > -1) {
        state.roles.splice(index, 1);
      }
    },
    [types.UPDATE_ROLE](state, newRole) {
      let index = state.roles.findIndex((role) => role._id === newRole._id);
      if (index > -1) {
        state.roles.splice(index, 1, newRole);
      }
    },
    //reminders mutation===================================
    [types.SET_REMINDER](state, reminders = []) {
      state.reminders.splice(0);
      state.reminders = reminders;
    },
    [types.DELETE_REMINDER](state, id) {
      let index = state.reminders.findIndex((role) => role._id === id);
      if (index > -1) {
        state.reminders.splice(index, 1);
      }
    },
    [types.UPDATE_REMINDER](state, reminder) {
      let index = state.reminders.findIndex((r) => r._id === reminder._id);
      if (index > -1) {
        state.reminders.splice(index, 1, reminder);
      } else {
        state.reminders.unshift(reminder);
      }
    },
    //synctool mutation===================================
    [types.SET_SYNC_TOOL](state, synctools = []) {
      state.synctools = synctools;
    },
    [types.ADD_SYNC_TOOL](state, synctool) {
      state.synctools.unshift(synctool);
    },
    [types.DELETE_SYNC_TOOL](state, id) {
      let index = state.synctools.findIndex((synctool) => synctool._id === id);
      if (index > -1) {
        state.synctools.splice(index, 1);
      }
    },
    [types.UPDATE_SYNC_TOOL](state, newSynctool) {
      let index = state.synctools.findIndex(
        (synctool) => synctool._id === newSynctool._id
      );
      if (index > -1) {
        state.synctools.splice(index, 1, newSynctool);
      } else {
        state.synctools.unshift(newSynctool);
      }
    },
    //device exam mutation===================================
    [types.SET_DEVICE_EXAM](state, deviceExams = []) {
      state.deviceExams = deviceExams;
    },
    [types.ADD_DEVICE_EXAM](state, exam) {
      state.deviceExams.push(exam);
    },
    [types.DELETE_DEVICE_EXAM](state, id) {
      let index = state.deviceExams.findIndex((exam) => exam._id === id);
      if (index > -1) {
        state.deviceExams.splice(index, 1);
      }
    },
    [types.UPDATE_DEVICE_EXAM](state, newExam) {
      let index = state.deviceExams.findIndex(
        (exam) => exam._id === newExam._id
      );
      if (index > -1) {
        state.deviceExams.splice(index, 1, newExam);
      }
    },
    //record exam mutation===================================
    [types.SET_RECORD_EXAM](state, recordExams = []) {
      state.recordExams = recordExams;
    },
    [types.ADD_RECORD_EXAM](state, exam) {
      state.recordExams.push(exam);
    },
    [types.DELETE_RECORD_EXAM](state, id) {
      let index = state.recordExams.findIndex((exam) => exam._id === id);
      if (index > -1) {
        state.recordExams.splice(index, 1);
      }
    },
    [types.UPDATE_RECORD_EXAM](state, newExam) {
      let index = state.recordExams.findIndex(
        (exam) => exam._id === newExam._id
      );
      if (index > -1) {
        state.recordExams.splice(index, 1, newExam);
      }
    },
  },
  getters: {
    setting: (state) => {
      return state.setting;
    },
    activeStaff: (state) => {
      return state.staffs.filter(
        (staff) => staff.status || !staff.hasOwnProperty("status")
      );
    },
    allStaff: (state) => {
      state.staffs.forEach((staff) => {
        if (staff.status === false) staff.name += "(已離職)";
      });
      return state.staffs;
    },
    userPetOptions: (state, getters) => {
      let petGroupByUser = {};
      state.pets.forEach((pet) => {
        if (pet) {
          if (!petGroupByUser.hasOwnProperty(pet.userID)) {
            petGroupByUser[pet.userID] = [];
          }
          petGroupByUser[pet.userID].push(pet);
        }
      });
      let userPetOptions = [];
      state.users.forEach((user) => {
        if (user) {
          (petGroupByUser[user._id] || []).forEach((userPet) => {
            userPetOptions.push({
              userID: user._id,
              petID: userPet._id,
              userName: user.name,
              petName: userPet.name,
              phone: user.phone,
              _id: user._id + "@" + userPet._id,
            });
          });
        }
      });
      return userPetOptions;
    },
    // used for old schedule today overview. deprecated now
    // getTodayRecords(state) {
    //   const todayStart = window
    //     .dayjs()
    //     .startOf("date")
    //     .unix();
    //   const todayEnd = window
    //     .dayjs()
    //     .endOf("date")
    //     .unix();
    //   return state.todayRecords.filter((record) => {
    //     return (
    //       (record.dateTime >= todayStart && record.dateTime <= todayEnd) ||
    //       (record.inspectedDateTime >= todayStart &&
    //         record.inspectedDateTime <= todayEnd) ||
    //       (record.drugDispensedDateTime >= todayStart &&
    //         record.drugDispensedDateTime <= todayEnd) ||
    //       (record.receiveLog &&
    //         record.receiveLog.length > 0 &&
    //         record.receiveLog[record.receiveLog.length - 1].createDateTime >=
    //           todayStart &&
    //         record.receiveLog[record.receiveLog.length - 1].createDateTime <=
    //           todayEnd)
    //     );
    //   });
    // },
    // todayRecordLastUpdate: (state, getters) => {
    //   let updated = 0;
    //   getters.getTodayRecords.forEach((record) => {
    //     updated =
    //       record.updateDateTime > updated ? record.updateDateTime : updated;
    //     updated =
    //       record.statusUpdateDateTime > updated
    //         ? record.statusUpdateDateTime
    //         : updated;
    //   });
    //   return updated;
    // },
    getTodayBookings(state) {
      const todayStart = window.dayjs().startOf("date").unix();
      const todayEnd = window.dayjs().endOf("date").unix();
      return state.todayBookings.filter((booking) => {
        return (
          booking.dateTime >= todayStart &&
          booking.dateTime <= todayEnd &&
          booking.bookingStatus !== "pending" &&
          booking.bookingStatus !== "refuse"
        ); // 排除待審查的預約
      });
    },

    getTodayCheckData(state) {
      const todayStart = window.dayjs().startOf("date").unix();
      const todayEnd = window.dayjs().endOf("date").unix();
      return state.checkData.filter((pet) => {
        // console.log(JSON.stringify(pet));
        return (
          pet.updateDateTime >= todayStart && pet.updateDateTime <= todayEnd
        ); // 只抓今天更新的待審查寵物
      });
    },
    getTodayCheckBookings(state) {
      const todayStart = window.dayjs().startOf("date").unix();
      const todayEnd = window.dayjs().endOf("date").unix();
      return state.checkBooking.filter((booking) => {
        return (
          booking.updateDateTime >= todayStart &&
          booking.updateDateTime <= todayEnd
        ); // 只抓今天更新的待審查預約
      });
    },
    todayBookingLastUpdate(state, getters) {
      let updated = 0;
      getters.getTodayBookings.forEach((booking) => {
        updated =
          booking.updateDateTime > updated ? booking.updateDateTime : updated;
        updated =
          booking.checkInDateTime > updated ? booking.checkInDateTime : updated;
      });

      const todayStart = window.dayjs().startOf("date").unix();
      const todayEnd = window.dayjs().endOf("date").unix();
      state.todayRecords.forEach((record) => {
        if (
          record.dateTime >= todayStart &&
          record.dateTime <= todayEnd &&
          record.source === "standard"
        ) {
          updated =
            record.updateDateTime > updated ? record.updateDateTime : updated;
        }
      });

      return updated;
    },
    todayCheckDataLastUpdate(state, getters) {
      // console.log("todayCheckDataLastUpdate state", state.checkData);
      let updated = 0;
      getters.getTodayCheckData.forEach((pet) => {
        // console.log(JSON.stringify(pet));
        updated = pet.updateDateTime > updated ? pet.updateDateTime : updated;
      });

      return updated;
    },
    todayCheckBookingLastUpdate(state, getters) {
      // console.log("todayCheckBookingLastUpdate state", state.checkBooking);
      let updated = 0;
      getters.getTodayCheckBookings.forEach((booking) => {
        // console.log(JSON.stringify(booking));
        updated =
          booking.updateDateTime > updated ? booking.updateDateTime : updated;
      });

      return updated;
    },
    waitingLastUpdate: (state) => {
      let updated = 0;
      state.waiting.concat(state.todayRecords).forEach((record) => {
        if (record.status === 0) {
          updated =
            record.updateDateTime > updated ? record.updateDateTime : updated;

          if (record.examTask) {
            record.examTask.forEach((task) => {
              updated =
                task.finishDateTime > updated ? task.finishDateTime : updated;
            });
          }
          updated =
            record.examTaskSubmitDateTime > updated
              ? record.examTaskSubmitDateTime
              : updated;
        }
      });
      return updated;
    },
    getExamTodo(state) {
      //examTodo is initialed on install and not update anymore
      let examTodo = state.examTodo.slice();
      //todayRcord will always recevie new change, so use todayRecord to replace old examTodo
      state.todayRecords.forEach((todayRecord) => {
        let index = state.examTodo.findIndex(
          (todo) => todo._id === todayRecord._id
        );

        if (index === -1) {
          examTodo.push(todayRecord);
        } else {
          examTodo.splice(index, 1, todayRecord);
        }
      });

      //inHospitalTodo is initialed on install and not update anymore
      let inHospitalTodo = state.inHospitalTodo.slice();
      //inHospitalTodo will always recevie new change, so use todayRecord to replace old recordTodo
      state.todayInHospitals.forEach((todayInHospital) => {
        let index = state.inHospitalTodo.findIndex(
          (todo) => todo._id === todayInHospital._id
        );

        if (index === -1) {
          inHospitalTodo.push(todayInHospital);
        } else {
          inHospitalTodo.splice(index, 1, todayInHospital);
        }
      });

      return examTodo.concat(inHospitalTodo).filter((doc) => {
        if (
          (doc.collection === "inHospitalExam" ||
            doc.collection === "record") &&
          doc.examTask &&
          doc.examTask.length > 0 &&
          doc.examTask.find((task) => {
            return (
              task.type !== "院外" &&
              task.type !== "院內" &&
              task.createTaskDateTime
            );
          }) &&
          (!doc.examTaskSubmitDateTime ||
            doc.examTask.find((task) => {
              return (
                task.type !== "院外" &&
                task.type !== "院內" &&
                (task.createTaskDateTime > doc.examTaskSubmitDateTime ||
                  task.finishDateTime > doc.examTaskSubmitDateTime ||
                  (task.createTaskDateTime && !task.finishDateTime))
              );
            }))
        ) {
          return true;
        } else {
          return false;
        }
      });
    },
    getAllOutsourcingTodo(state) {
      //examTodo is initialed on install and not update anymore
      let examTodo = state.examTodo.slice();
      //todayRcord will always recevie new change, so use todayRecord to replace old examTodo
      state.todayRecords.forEach((todayRecord) => {
        let index = state.examTodo.findIndex(
          (todo) => todo._id === todayRecord._id
        );

        if (index === -1) {
          examTodo.push(todayRecord);
        } else {
          examTodo.splice(index, 1, todayRecord);
        }
      });

      //inHospitalTodo is initialed on install and not update anymore
      let inHospitalTodo = state.inHospitalTodo.slice();
      //inHospitalTodo will always recevie new change, so use todayRecord to replace old recordTodo
      state.todayInHospitals.forEach((todayInHospital) => {
        let index = state.inHospitalTodo.findIndex(
          (todo) => todo._id === todayInHospital._id
        );

        if (index === -1) {
          inHospitalTodo.push(todayInHospital);
        } else {
          inHospitalTodo.splice(index, 1, todayInHospital);
        }
      });

      return examTodo
        .concat(inHospitalTodo)
        .filter(
          (doc) =>
            (doc.collection === "record" ||
              doc.collection === "inHospitalExam") &&
            doc.examTask &&
            doc.examTask.length > 0 &&
            doc.examTask.find((task) => task.type === "院外")
        );
    },
    getAllInsideTodo(state) {
      //examTodo is initialed on install and not update anymore
      let examTodo = state.examTodo.slice();
      //todayRcord will always recevie new change, so use todayRecord to replace old examTodo
      state.todayRecords.forEach((todayRecord) => {
        let index = state.examTodo.findIndex(
          (todo) => todo._id === todayRecord._id
        );

        if (index === -1) {
          examTodo.push(todayRecord);
        } else {
          examTodo.splice(index, 1, todayRecord);
        }
      });

      //inHospitalTodo is initialed on install and not update anymore
      let inHospitalTodo = state.inHospitalTodo.slice();
      //inHospitalTodo will always recevie new change, so use todayRecord to replace old recordTodo
      state.todayInHospitals.forEach((todayInHospital) => {
        let index = state.inHospitalTodo.findIndex(
          (todo) => todo._id === todayInHospital._id
        );

        if (index === -1) {
          inHospitalTodo.push(todayInHospital);
        } else {
          inHospitalTodo.splice(index, 1, todayInHospital);
        }
      });

      return examTodo
        .concat(inHospitalTodo)
        .filter(
          (doc) =>
            (doc.collection === "record" ||
              doc.collection === "inHospitalExam") &&
            doc.examTask &&
            doc.examTask.length > 0 &&
            doc.examTask.find((task) => task.type === "院內")
        );
    },
    examTodoLastUpdate(state, getters) {
      let updated = 0;
      getters.getExamTodo.forEach((doc) => {
        updated = doc.updateDateTime > updated ? doc.updateDateTime : updated;

        doc.examTask
          .filter((task) => task.type !== "院外" && task.type !== "院內")
          .forEach((task) => {
            updated =
              task.createTaskDateTime > updated
                ? task.createTaskDateTime
                : updated;
            updated =
              task.requestDateTime > updated ? task.requestDateTime : updated;
            updated =
              task.finishDateTime > updated ? task.finishDateTime : updated;
          });
      });
      return updated;
    },
    outsourcingTodoLastUpdate(state, getters) {
      let updated = 0;
      getters.getAllOutsourcingTodo.forEach((doc) => {
        updated = doc.updateDateTime > updated ? doc.updateDateTime : updated;

        doc.examTask
          .filter((task) => task.type === "院外")
          .forEach((task) => {
            updated =
              task.createTaskDateTime > updated
                ? task.createTaskDateTime
                : updated;
            updated =
              task.requestDateTime > updated ? task.requestDateTime : updated;
            updated =
              task.finishDateTime > updated ? task.finishDateTime : updated;
          });
      });
      return updated;
    },
    insideTodoLastUpdate(state, getters) {
      let updated = 0;
      getters.getAllInsideTodo.forEach((doc) => {
        updated = doc.updateDateTime > updated ? doc.updateDateTime : updated;

        doc.examTask
          .filter((task) => task.type === "院內")
          .forEach((task) => {
            updated =
              task.createTaskDateTime > updated
                ? task.createTaskDateTime
                : updated;
            updated =
              task.requestDateTime > updated ? task.requestDateTime : updated;
            updated =
              task.finishDateTime > updated ? task.finishDateTime : updated;
          });
      });
      return updated;
    },
    getDrugTodo(state) {
      //dispenseTodo is initialed on install and not update anymore
      let dispenseTodo = state.dispenseTodo.slice();
      //todayRcord will always recevie new change, so use todayRecord to replace old dispenseTodo
      state.todayRecords.forEach((todayRecord) => {
        let index = state.dispenseTodo.findIndex(
          (todo) => todo._id === todayRecord._id
        );

        if (index === -1) {
          dispenseTodo.push(todayRecord);
        } else {
          dispenseTodo.splice(index, 1, todayRecord);
        }
      });

      return dispenseTodo.filter((record) => {
        // used for old schedule today overview. deprecated now
        // inspected status + (drug bag | drug bag note | controlled drug bag)
        // let case1 =
        //   record.status == window.NxVetV2.RECORD_STATUS.INSPECTED &&
        //   ((record.drugBag && record.drugBag.length > 0) ||
        //     (record.drugBagNote && record.drugBagNote != "") ||
        //     (record.controlledDrugBag && record.controlledDrugBag.length > 0));

        // above inspected status + (not dispensed drug | not dispensed controlled drug)
        // let case2 =
        //   record.status > window.NxVetV2.RECORD_STATUS.INSPECTED &&
        //   ((record.drugBag &&
        //     record.drugBag.length > 0 &&
        //     record.drugBag.find((bag) => !bag.dispensed)) ||
        //     (record.controlledDrugBag &&
        //       record.controlledDrugBag.length > 0 &&
        //       record.controlledDrugBag.find((bag) => !bag.dispensed)));

        // record status V2
        let case3 =
          record.dispenseStatus &&
          record.dispenseStatus === window.NxVetV2.executionStatus.requested;

        return case3;
      });
    },

    getInHospitalDrugTodo(state) {
      //inHospitalTodo is initialed on install and not update anymore
      let inHospitalTodo = state.inHospitalTodo.slice();
      //inHospitalTodo will always recevie new change, so use todayRecord to replace old recordTodo
      state.todayInHospitals.forEach((todayInHospital) => {
        let index = state.inHospitalTodo.findIndex(
          (todo) => todo._id === todayInHospital._id
        );

        if (index === -1) {
          inHospitalTodo.push(todayInHospital);
        } else {
          inHospitalTodo.splice(index, 1, todayInHospital);
        }
      });

      return inHospitalTodo.filter((inHospital) => {
        return (
          inHospital.collection === "inHospitalPlan" &&
          inHospital.dispensingReadyDateTime &&
          inHospital.drugBag &&
          inHospital.drugBag.length &&
          (inHospital.drugBag.find((bag) => !bag.dispensed) ||
            !inHospital.drugDispensedDateTime)
        );
      });
    },

    drugTodoLastUpdate(state, getters) {
      let updated = 0;
      getters.getDrugTodo.forEach((record) => {
        updated =
          record.updateDateTime > updated ? record.updateDateTime : updated;
        updated =
          record.drugDispensedDateTime > updated
            ? record.drugDispensedDateTime
            : updated;
      });

      return updated;
    },

    inHospitalDrugTodoLastUpdate(state, getters) {
      let updated = 0;

      getters.getInHospitalDrugTodo.forEach((inHospital) => {
        updated =
          inHospital.updateDateTime > updated
            ? inHospital.updateDateTime
            : updated;
        updated =
          inHospital.drugDispensedDateTime > updated
            ? inHospital.drugDispensedDateTime
            : updated;
      });

      return updated;
    },

    getDrugTodayDone(state) {
      const todayStart = window.dayjs().startOf("date").unix();
      let dispenseTodo = state.dispenseTodo.slice();
      state.todayRecords.forEach((todayRecord) => {
        let index = state.dispenseTodo.findIndex(
          (todo) => todo._id === todayRecord._id
        );

        if (index === -1) {
          dispenseTodo.push(todayRecord);
        } else {
          dispenseTodo.splice(index, 1, todayRecord);
        }
      });

      let inHospitalTodo = state.inHospitalTodo.slice();
      state.todayInHospitals.forEach((todayInHospital) => {
        let index = state.inHospitalTodo.findIndex(
          (todo) => todo._id === todayInHospital._id
        );

        if (index === -1) {
          inHospitalTodo.push(todayInHospital);
        } else {
          inHospitalTodo.splice(index, 1, todayInHospital);
        }
      });

      return dispenseTodo
        .filter((record) => {
          let done =
            record.collection === "record" &&
            record.dispenseStatus &&
            record.dispenseStatus === window.NxVetV2.executionStatus.done;
          return done;
        })
        .concat(
          inHospitalTodo.filter((inHospital) => {
            let done =
              inHospital.collection === "inHospitalPlan" &&
              inHospital.dispensingReadyDateTime &&
              inHospital.drugBag &&
              inHospital.drugBag.length &&
              !inHospital.drugBag.find((bag) => !bag.dispensed);
            return done;
          })
        )
        .filter((record) => {
          let todayDone =
            record.drugDispensedDateTime &&
            record.drugDispensedDateTime >= todayStart;
          return todayDone;
        });
    },

    getTodayCheckout(state) {
      const todayStart = window.dayjs().startOf("date").unix();
      const todayEnd = window.dayjs().endOf("date").unix();

      //inHospitalBilling is initialed on install and not update anymore
      let inHospitalBilling = state.inHospitalBilling.slice();
      //todayInHospitals will always recevie new change, so use todayRecord to replace old recordTodo
      state.todayInHospitals.forEach((todayInHospital) => {
        let index = state.inHospitalBilling.findIndex(
          (todo) => todo._id === todayInHospital._id
        );

        if (index === -1) {
          inHospitalBilling.push(todayInHospital);
        } else {
          inHospitalBilling.splice(index, 1, todayInHospital);
        }
      });

      return state.todayRecords
        .filter((record) => {
          return (
            record.billStatus &&
            record.billStatus >= window.NxVetV2.executionStatus.requested
          );
        })
        .concat(
          inHospitalBilling.filter(
            (inHospital) =>
              inHospital.collection === "inHospital" &&
              inHospital.settleDateTime >= todayStart &&
              inHospital.settleDateTime <= todayEnd
          )
        );
    },
    todayCheckoutLastUpdate: (state, getters) => {
      let updated = 0;
      getters.getTodayCheckout.forEach((record) => {
        if (record.receiveLog && record.receiveLog.length) {
          updated =
            record.receiveLog[record.receiveLog.length - 1].createDateTime >
            updated
              ? record.receiveLog[record.receiveLog.length - 1].createDateTime
              : updated;
        }
        updated =
          record.updateDateTime > updated ? record.updateDateTime : updated;
      });
      return updated;
    },
    getLastArchivedExam(state) {
      return state.deviceExams
        .filter((exam) => exam.attachedID)
        .sort(
          (exam1, exam2) =>
            exam2.deviceUpdateDateTime - exam1.deviceUpdateDateTime
        );
    },
    lastArchivedExamLastUpdate(state, getters) {
      let updated = 0;

      getters.getLastArchivedExam.forEach((exam) => {
        updated =
          exam.deviceUpdateDateTime > updated
            ? exam.deviceUpdateDateTime
            : updated;
        updated = exam.updateDateTime > updated ? exam.updateDateTime : updated;
      });
      return updated;
    },
    getLastNotArchivedExam(state) {
      return state.deviceExams
        .filter((exam) => !exam.attachedID)
        .sort(
          (exam1, exam2) =>
            exam2.deviceUpdateDateTime - exam1.deviceUpdateDateTime
        );
    },
    lastNotArchivedExamLastUpdate(state, getters) {
      let updated = 0;

      getters.getLastNotArchivedExam.forEach((exam) => {
        updated =
          exam.deviceUpdateDateTime > updated
            ? exam.deviceUpdateDateTime
            : updated;
        updated = exam.updateDateTime > updated ? exam.updateDateTime : updated;
      });
      return updated;
    },
    getVerifyTodo(state) {
      return state.verifyTodo
        .filter((verify) => verify.verifyStatus == 0)
        .sort(
          (verify1, verify2) => verify2.applyDateTime - verify1.applyDateTime
        );
    },
    getLastAppliedVerify(state) {
      return state.verifyTodo
        .filter((verify) => verify.verifyStatus == 10)
        .sort(
          (verify1, verify2) => verify2.applyDateTime - verify1.applyDateTime
        );
    },
    getLastUnappliedVerify(state) {
      return state.verifyTodo
        .filter((verify) => verify.verifyStatus == 90)
        .sort(
          (verify1, verify2) => verify2.applyDateTime - verify1.applyDateTime
        );
    },
    verifyTodoExist(state, getters) {
      // let updated = 0;
      // getters.getVerifyTodo.forEach((verify) => {
      //   updated =
      //     verify.updateDateTime > updated ? verify.updateDateTime : updated;
      // });

      // return updated;
      return getters.getVerifyTodo.length;
    },
  },
};

export default module;
